import React, {useEffect, useRef, useState} from "react"

const MAX_RETRIES = 3
const BASE_DELAY_MS = 600

/**
 * <img> avec retry exponentiel en cas d'echec de chargement.
 * Si toutes les tentatives echouent, rend `fallback` a la place.
 *
 * Cle "src" : si elle change, on reset les tentatives.
 */
export default function SmartImage({src, alt, className, style, loading, fallback = null, onLoad}) {
    const [attempt, setAttempt] = useState(0)
    const [failed, setFailed] = useState(false)
    const timerRef = useRef(null)

    useEffect(() => {
        setAttempt(0)
        setFailed(false)
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current)
        }
    }, [src])

    if (!src || failed) return fallback

    const cacheBuster = attempt > 0 ? `${src.includes("?") ? "&" : "?"}_r=${attempt}` : ""

    return (
        <img
            src={src + cacheBuster}
            alt={alt || ""}
            className={className}
            style={style}
            loading={loading}
            onLoad={onLoad}
            onError={() => {
                if (attempt < MAX_RETRIES) {
                    const delay = BASE_DELAY_MS * Math.pow(2, attempt)
                    timerRef.current = setTimeout(() => {
                        setAttempt(a => a + 1)
                    }, delay)
                } else {
                    setFailed(true)
                }
            }}
        />
    )
}
